module.exports = __webpack_public_path__ + "static/media/history.96296fa4.png";